import { render } from "./FaceRecognition.vue?vue&type=template&id=2cca818a&scoped=true"
import script from "./FaceRecognition.vue?vue&type=script&lang=js"
export * from "./FaceRecognition.vue?vue&type=script&lang=js"

import "./FaceRecognition.vue?vue&type=style&index=0&id=2cca818a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cca818a"]])

export default __exports__